export default Object.freeze({
  900595: 900595,
  900597: 900597,
  900599: 900599,
  900601: 900601,
});



// WEBPACK FOOTER //
// ./src/enums/modules/productCodeDiscountDynamic.js